export const VALID_EMAIL_REGEX = /.+@.+\..+/;
export const VALID_URL_REGEX = /^https?:\/\//; // Hahaha
export const VALID_STORY_URL_REGEX = /^https?:\/\/.+\/stories\/s\/(.+\/)?\w{4}-\w{4}(\/edit)?\/?$/;
export const TRAILING_UID_REGEX = /(\w{4}-\w{4})\/?$/;
export const UID_REGEX = /^(\w{4}-\w{4})\/?$/;
